<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col">
				<div
					:class="!showFilters ? 'btn-primary' : 'btn-secondary'"
					class="btn mx-1 bg-primary-alt"
					@click="showFilters = !showFilters">
					<i
						class="fa fa-filter"
						aria-hidden="true" />
				</div>
				<div class="btn btn-lg">
					{{ datePeriod }}
				</div>
				<b-button
					class="float-right"
					variant="primary"
					@click="downloadReport">
					<i class="fas fa-file-excel" /> {{ translate('export') }}
				</b-button>
			</div>
		</div>
		<hr>
		<data-filter
			:display="showFilters"
			get-by="name"
			@submit="getDataFiltered"
			@clear="clearFilters">
			<template slot="form">
				<div class="row">
					<div class="col-sm">
						<div
							class="form-group">
							<label
								for="month"
								class="label">{{ translate('month') }}</label>
							<select
								id="month"
								v-model="selectedMonth"
								name="month"
								class="form-control">
								<option
									:key="0"
									:value="0">
									{{ translate('all') }}
								</option>
								<option
									v-for="index in 12"
									:key="index"
									:value="index">
									{{ $moment(index,'MM').format('MMMM') }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-sm">
						<div
							class="form-group">
							<label
								for="year"
								class="label">{{ translate('year') }}</label>
							<select
								id="year"
								v-model="selectedYear"
								name="year"
								class="form-control">
								<option
									v-for="year in years"
									:key="year"
									:value="year">
									{{ year }}
								</option>
							</select>
						</div>
					</div>
				</div>
			</template>
		</data-filter>
		<b-row>
			<b-col class="col-12">
				<router-view />
			</b-col>
		</b-row>
	</div>
</template>
<script>

import {
	Report, Grids, Dates, Order,
} from '@/translations';
import FiltersParams from '@/mixins/FiltersParams';

import DataFilter from '@/components/DataFilter';
import FraudOrders from '@/util/Report';
import {
	FRAUD_START_YEAR,
} from '@/settings/Dates';

export default {
	name: 'FraudOrders',
	messages: [Report, Grids, Dates, Order],
	components: { DataFilter },
	mixins: [FiltersParams],
	data() {
		return {
			selectedMonth: this.$moment().month() + 1,
			selectedYear: this.$moment().year(),
			FraudOrders: new FraudOrders(),
			rangeStart: '',
			rangeEnd: '',
		};
	},
	computed: {
		loading() {
			return !!this.FraudOrders.data.loading;
		},
		data() {
			try {
				const { response } = this.FraudOrders.data.response.data;
				return response;
			} catch (error) {
				return [];
			}
		},
		datePeriod() {
			return this.getDatePeriod();
		},
		query() {
			return this.$route.query;
		},
		years() {
			const startingYear = FRAUD_START_YEAR;
			const endingYear = this.$moment().year();
			const years = [];
			for (let index = startingYear; index <= endingYear; index += 1) {
				years.push(index);
			}
			return years;
		},
	},
	mounted() {
		const urlParams = this.$route.query;
		if (typeof urlParams !== 'undefined') {
			if (urlParams.month) this.selectedMonth = urlParams.month;
			if (urlParams.year) this.selectedYear = urlParams.year;
		}

		this.getDataFiltered();

		return null;
	},
	methods: {
		getDataFiltered(page) {
			if (typeof page === 'object') {
				this.filters = { ...this.filters, ...page };
			}

			const { query } = this.$route;
			const options = { ...query, ...this.filters };

			Object.keys(options).forEach((item) => {
				if (!options[item]) {
					delete options[item];
				}
			});

			this.$router.push({ name: 'FraudOrdersAll', query: options }).catch(() => {});
		},
		getDatePeriod() {
			const start = this.rangeStart;
			const end = this.rangeEnd;
			if (start !== '' && end !== '') {
				return this.translate('date_period', { start, end });
			}

			if (start !== '') {
				return this.translate('date_period_from', { start });
			}

			if (end !== '') {
				return this.translate('date_period_until', { end });
			}
			return '';
		},
		downloadReport() {
			const fraudOrders = new FraudOrders();
			const loading = new this.$Alert();
			loading.loading(this.translate('loading'), this.translate('loading_text'), { allowOutsideClick: false, allowEscapeKey: false });
			fraudOrders.downloadOrders().then(() => {
				const { response } = fraudOrders.data;
				const url = window.URL.createObjectURL(response.data);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${this.translate('fraud_orders')} - ${this.$moment().format('YYYY-MM-DD')}.xlsx`);
				this.$el.appendChild(link);
				link.click();
				loading.close();
			}).catch(() => {
				loading.close();
			});
		},

	},
};
</script>
